import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeModal } from '../../redux/actions';
import { Button } from '../../components';

import { ModalContainer, ModalBody, ModalHeading, ModalDescription, ModalCloseButton, ModalButtonContainer, ModalColouredHeading } from './styles';

const mapDispatchToProps = dispatch => bindActionCreators({
  handleCloseButtonClick: closeModal,
}, dispatch);

@connect(null, mapDispatchToProps)
class Modal extends Component {
  static propTypes = {
    heading: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
    children: PropTypes.node,
    buttonText: PropTypes.string,
    handleButtonClick: PropTypes.func,
    handleCloseButtonClick: PropTypes.func,
    empty: PropTypes.bool,
    noButton: PropTypes.bool,
    overflow: PropTypes.string,
    mobileMaxWidth: PropTypes.string,
    maxWidth: PropTypes.string,
    customCloseFunc: PropTypes.func,
  };

  static defaultProps = {
    overflow: 'hidden',
    mobileMaxWidth: '300px',
    maxWidth: '450px',
  }; 

  render() {
    const { heading, customCloseFunc, description, children, buttonText, handleButtonClick, handleCloseButtonClick, empty, noButton, overflow, maxWidth, mobileMaxWidth, colouredHeader } = this.props;
    return (
      <ModalContainer>
        <ModalBody noButton={noButton} overflow={overflow} maxWidth={maxWidth} mobileMaxWidth={mobileMaxWidth}>
          <OutsideClickHandler onOutsideClick={customCloseFunc || handleCloseButtonClick}>
            {!noButton && <ModalCloseButton onClick={customCloseFunc || handleCloseButtonClick} />}
            {empty ? (
              <Fragment>
                {children}
              </Fragment>
            ) : (
              <Fragment>
              {
                colouredHeader ? 
                <ModalColouredHeading>{heading}</ModalColouredHeading>
                :
                <ModalHeading>{heading}</ModalHeading>
              }
                <ModalDescription>{description}</ModalDescription>
                {children}
                {
                  buttonText &&
                  <ModalButtonContainer>
                    <Button htmlType="button" theme="primary" onClick={handleButtonClick || customCloseFunc || handleCloseButtonClick}>{buttonText}</Button>
                  </ModalButtonContainer>
                }
              </Fragment>
            )}
          </OutsideClickHandler>
        </ModalBody>
      </ModalContainer>
    )
  }
}

export default Modal;
